import { ModuleLayout, NavigationItem } from '@/components/ModuleLayout'
import {
  LayoutDashboard,
  Building2,
  CalendarDays,
  Repeat,
} from 'lucide-react'

const navigation: NavigationItem[] = [
  {
    name: 'Calendario',
    href: '/rentals/dashboard',
    icon: LayoutDashboard,
  },
  {
    name: 'Espacios',
    href: '/rentals/spaces',
    icon: Building2,
  },
  {
    name: 'Reservas',
    href: '/rentals/bookings',
    icon: CalendarDays,
  },
  {
    name: 'Reservas Fijas',
    href: '/rentals/series',
    icon: Repeat,
  },
]

export function RentalsLayout({ children }: { children: React.ReactNode }) {
  return (
    <ModuleLayout
      moduleName="Alquiler de Espacios"
      moduleIcon={Building2}
      moduleColor="from-cyan-500 to-cyan-600"
      navigation={navigation}
    >
      {children}
    </ModuleLayout>
  )
}
